import { Fragment, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useCreateCashTransferMutation } from '../../../redux/api/marktApi';
import { useApiErrorToast } from '../../../hooks/useApiError';

// One modal drives both directions: a deposit (IN, e.g. topping up change) and
// a withdrawal (OUT, taking cash out of a running register).
const CONFIG = {
  IN: {
    title: 'Einzahlung',
    icon: 'arrow-down',
    variant: 'outline-success',
    help: 'Bargeld in die laufende Kasse einlegen (z.B. Wechselgeld).',
    placeholder: 'z.B. Wechselgeld',
  },
  OUT: {
    title: 'Entnahme',
    icon: 'arrow-up',
    variant: 'outline-warning',
    help: 'Bargeld aus der laufenden Kasse entnehmen.',
    placeholder: 'z.B. Überschuss abschöpfen',
  },
};

const CashTransferModal = ({ session, direction }) => {
  const cfg = CONFIG[direction];
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState('');
  const [comment, setComment] = useState('');
  const [doTransfer, { isLoading }] = useCreateCashTransferMutation();
  const apiErrorToast = useApiErrorToast();

  const reset = () => {
    setAmount('');
    setComment('');
  };
  const close = () => {
    if (isLoading) return;
    reset();
    setShowModal(false);
  };

  const handleSubmit = async () => {
    const value = parseFloat(amount);
    if (!(value > 0)) {
      toast.error('Bitte einen Betrag größer als 0 eingeben.');
      return;
    }
    try {
      const result = await doTransfer({
        sessionId: session.id,
        payload: { type: direction, amount, comment },
      }).unwrap();
      toast.success(
        `${cfg.title} verbucht. Neuer Kassenstand: ${result.balance} €`
      );
      reset();
      setShowModal(false);
    } catch (err) {
      apiErrorToast(err, `${cfg.title} fehlgeschlagen`);
    }
  };

  return (
    <Fragment>
      <Button
        variant={cfg.variant}
        size='sm'
        onClick={() => setShowModal(true)}
      >
        <i className={`fas fa-${cfg.icon} me-1`} />
        {cfg.title}
      </Button>
      <Modal show={showModal} onHide={close} backdrop={'static'}>
        <Modal.Header closeButton={!isLoading}>
          <Modal.Title>
            {cfg.title} – {session.cash_register_name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className='text-muted'>{cfg.help}</p>
          <Form.Group className='mb-3'>
            <Form.Label>Betrag (€)</Form.Label>
            <Form.Control
              type='number'
              min='0.01'
              step='0.01'
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              autoFocus
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Kommentar (optional)</Form.Label>
            <Form.Control
              type='text'
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder={cfg.placeholder}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={close} disabled={isLoading}>
            abbrechen
          </Button>
          <Button variant='success' onClick={handleSubmit} disabled={isLoading}>
            {cfg.title} verbuchen
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default CashTransferModal;
